import { 
    filterStatisticWarrantyMonth, 
    filterStatisticWarrantyDaily, 
    filterStatisticAppUserDaily,
    getFormatWarrantyMonthGraph, 
    getFormatWarrantyDailyGraph, 
    getFormatAppUsersDailyGraph,
    getYear 
} from "functions/functions";

const initialState = {
    isLoading: false,
    warranty_month: {
        "label": [],
        "data": [],
    },
    warranty_daily: {
        "label": [],
        "data": [],
    },
    appuser_month: {
        "label": [],
        "data": [],
    },
    appuser_daily: {
        "label": [],
        "data": [],
    },
    options_year: [],
    options_month: [],
    options_region: [],
    options_province: [],
    current_year: "",
    warranty_monthTem: [],
    warranty_dailyTem: [],
    mapData: {},

    count_appusers: "0",
    count_app_totalpreviousyear: "0",
    count_appusers_sendwarranty: "0",
    count_allwarranty: "0",
    count_confirmwarranty: "0",
    count_noconfirmwarranty: "0",
    count_waitconfirmwarranty: "0",

    warranty_region: {
        report_region: [],
        total_warranty: "0",
        total_percent_region: "100"
    },

    // select statistis warranty
    selected_sw_year: "",
    selected_sw_month: "0",
    selected_sw_region: "0",
    selected_sw_province: "0",

    // select statistis app user
    selected_sa_year: "",
    selected_sa_month: "0",
}

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_STATISTIC_WARRANTY": {
            return { 
                ...state, 
                selected_sa_year: action.selected_year,
                warranty_month: action.month,
                warranty_monthTem: action.tem_month,
                warranty_dailyTem: action.tem_daily
            }
        }
        case "GET_STATISTIC_APPUSERS": {
            return {
                ...state,
                selected_sa_year: action.selected_year,
                count_app_totalpreviousyear: action.total_previous,
                appuser_month: action.month,
                appuser_monthTem: action.tem_month,
                appuser_dailyTem: action.tem_daily
            }
        }
        case "GET_COUNTAPPUSERS": {
            return {
                ...state,
                count_appusers: action.data
            }
        }
        case "GET_COUNTAPPUSERS_SENDWARRANTY": {
            return {
                ...state,
                count_appusers_sendwarranty: action.data
            }
        }
        case "GET_COUNT_ALL_WARRANTY": {
            return {
                ...state,
                count_allwarranty: action.data
            }
        }
        case "GET_COUNT_CONFIRM_WARRANTY": {
            return {
                ...state,
                count_confirmwarranty: action.data
            }
        }
        case "GET_COUNT_NOCONFIRM_WARRANTY": {
            return {
                ...state,
                count_noconfirmwarranty: action.data
            }
        }
        case "GET_COUNT_WAITCONFIRM_WARRANTY": {
            return {
                ...state,
                count_waitconfirmwarranty: action.data
            }
        }
        case "GET_OPTIONSYEAR": {
            return {
                ...state,
                options_year: action.options_year,
            }
        }
        case "GET_OPTIONSREGION": {
            return {
                ...state,
                options_region: action.data
            }
        }
        case "GET_OPTIONSPROVINCE": {
            return {
                ...state,
                options_province: action.data
            }
        }
        case "SELECT_SW_MONTH": {
            let filter_daily_selected = filterStatisticWarrantyDaily(state.warranty_dailyTem, action.select, state.selected_sw_region, state.selected_sw_province);
            let warranty_dailyFormat = getFormatWarrantyDailyGraph(filter_daily_selected);

            return {
                ...state,
                selected_sw_month: action.select,
                warranty_daily: warranty_dailyFormat
            }
        }
        case "SELECT_SW_REGION": {
            // ไม่ได้ระบุเดือน
            if(state.selected_sw_month === "0") {
                let filter_month_selected = filterStatisticWarrantyMonth(state.warranty_monthTem, action.select, "0");
                let warranty_monthFormat = getFormatWarrantyMonthGraph(filter_month_selected, getYear(state.selected_sw_year));

                return {
                    ...state,
                    selected_sw_region: action.select,
                    selected_sw_province: "0",
                    options_province: action.options,
                    warranty_month: warranty_monthFormat,
                }
            }
            // ระบุเดือน
            else {
                let filter_daily_selected = filterStatisticWarrantyDaily(state.warranty_dailyTem, state.selected_sw_month, action.select, "0");
                let warranty_dailyFormat = getFormatWarrantyDailyGraph(filter_daily_selected);

                return {
                    ...state,
                    selected_sw_region: action.select,
                    selected_sw_province: "0",
                    options_province: action.options,
                    warranty_daily: warranty_dailyFormat,
                }
            }
        }
        case "SELECT_SW_PROVINCE": {
            // ไม่ได้ระบุเดือน
            if(state.selected_sw_month === "0") {
                let filter_month_selected = filterStatisticWarrantyMonth(state.warranty_monthTem, state.selected_sw_region, action.data);
                let warranty_monthFormat = getFormatWarrantyMonthGraph(filter_month_selected, getYear(state.selected_sw_year));
    
                return {
                    ...state,
                    selected_sw_province: action.data,
                    warranty_month: warranty_monthFormat
                }
            } 
            // ระบุเดือน
            else {
                let filter_daily_selected = filterStatisticWarrantyDaily(state.warranty_dailyTem, state.selected_sw_month, state.selected_sw_region, action.data);
                let warranty_dailyFormat = getFormatWarrantyDailyGraph(filter_daily_selected);

                return {
                    ...state,
                    selected_sw_province: action.data,
                    warranty_daily: warranty_dailyFormat
                }
            }
        }
        case "SELECT_SA_MONTH": {
            let appuser_dailyFormat = getFormatAppUsersDailyGraph(state.appuser_dailyTem, action.select, state.count_app_totalpreviousyear);

            return {
                ...state,
                selected_sa_month: action.select,
                appuser_daily: appuser_dailyFormat
            }
        }
        case "GET_WARRANTYREGION": {
            let data = action.data;

            let warranty_region = {
                report_region: data.report_region,
                total_warranty: data.total_warranty,
                total_percent_region: data.total_percent_region
            }

            return {
                ...state,
                warranty_region: warranty_region,
                mapData: action.mapData
            }
        }
        default: {
            return state
        }
    }
}

export default dashboardReducer;